import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = {
  children: ReactNode
  fallback?: ReactNode
}

type State = {
  hasError: boolean
  error: Error | null
}

export class RootErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Root error boundary caught:', error, errorInfo)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback

      return (
        <div
          dir="rtl"
          className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center"
        >
          <h1 className="text-xl font-semibold text-foreground">حدث خطأ غير متوقع</h1>
          <p className="text-sm text-muted-foreground">
            يرجى تحديث الصفحة أو المحاولة مرة أخرى.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground transition-all duration-100 active:scale-[0.97]"
          >
            تحديث الصفحة
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
